/* eslint-disable no-negated-condition */
/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { compose, withReducer, withHandlers, mapProps } from 'recompose';
import _ from 'lodash';

const LOAD = '@@list/LOAD';
const TOGGLE_ALL = '@@list/TOGGLE_ALL';
const TOGGLE_SERVICE = '@@list/TOGGLE_SERVICE';
const TOGGLE_SERVICE_SEVERITY = '@@list/TOGGLE_SERVICE_SEVERITY';

// Helper functions to determine if all severities are checked or only some
const allSeverities = (s) => s.major && s.minor && s.maintenance;
const someSeverities = (s) => s.major || s.minor || s.maintenance;

/**
 * Example State
 * [{
 *   serviceKey: 'coreService', major: true, minor: true, maintenance: true
 * }, {
 *   serviceKey: 'api', major: true, minor: true, maintenance: false
 * }, {
 *   serviceKey: 'web', major: false, minor: false, maintenance: false
 * }]
 */

export const initialState = {};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case LOAD: {
      return action.value;
    }
    case TOGGLE_ALL: {
      const { value, subType } = action;
      const nonType = subType === 'email' ? 'sms' : 'email';
      const newState = { [subType]: state[subType].map((s) => ({ serviceKey: s.serviceKey, major: value, minor: value, maintenance: value })), [nonType]: state[nonType] };
      return newState;
    }
    case TOGGLE_SERVICE: {
      const { serviceKey, value, subType } = action;
      const nonType = subType === 'email' ? 'sms' : 'email';
      const i = state[subType].findIndex((s) => s.serviceKey === serviceKey);
      const newServiceState = { serviceKey: serviceKey, major: value, minor: value, maintenance: value };
      const newStateType = [...state[subType].slice(0, i), newServiceState, ...state[subType].slice(i+1)];
      const newState = {[subType]: newStateType, [nonType]: state[nonType] }
      return newState;
    }
    case TOGGLE_SERVICE_SEVERITY: {
      const { serviceKey, severity, value, subType } = action;
      const nonType = subType === 'email' ? 'sms' : 'email';
      const i = state[subType].findIndex((s) => s.serviceKey === serviceKey);
      const newServiceState = { ...state[subType][i], [severity]: value };
      const newStateType = [...state[subType].slice(0, i), newServiceState, ...state[subType].slice(i + 1)];
      const newState = { [subType]: newStateType, [nonType]: state[nonType] }
      return newState;
    }
    default: {
      return state;
    }
  }
};

const connect = () => compose(
  withReducer('serviceSeverityGrid', 'dispatch',
    reducer,

  ),
  withHandlers({
    load: ({ dispatch }) => (value) => dispatch({
      type: LOAD,
      value,
    }),
    toggleAll: ({ dispatch }) => (value, subType) => dispatch({
      type: TOGGLE_ALL,
      value,
      subType
    }),
    toggleService: ({ dispatch }) => (serviceKey, value, subType) => dispatch({
      type: TOGGLE_SERVICE,
      serviceKey,
      value,
      subType
    }),
    toggleServiceSeverity: ({ dispatch }) => (serviceKey, severity, value, subType) => dispatch({
      type: TOGGLE_SERVICE_SEVERITY,
      serviceKey,
      severity,
      value,
      subType
    }),
  }),
  mapProps(({ serviceSeverityGrid, load, toggleAll, toggleService, toggleServiceSeverity, dispatch, ...rest }) => {
    const state = {};
    if (!_.isEmpty(serviceSeverityGrid)) {
      state.allCheckedEmail = _.every(serviceSeverityGrid.email.map(allSeverities));
      state.allIndeterminateEmail = !state.allCheckedEmail && _.some(serviceSeverityGrid.email.map(someSeverities));

      state.allCheckedSMS = _.every(serviceSeverityGrid.sms.map(allSeverities));
      state.allIndeterminateSMS = !state.allCheckedSMS && _.some(serviceSeverityGrid.email.map(someSeverities));

      state.services = serviceSeverityGrid.email.map((service) => {
        const serviceState = { ...service };
        serviceState.checked = allSeverities(service);
        serviceState.indeterminate = !serviceState.checked && someSeverities(service);
        return serviceState;
      });
      state.servicesSMS = serviceSeverityGrid.sms.map((service) => {
        const serviceState = { ...service };
        serviceState.checked = allSeverities(service);
        serviceState.indeterminate = !serviceState.checked && someSeverities(service);
        return serviceState;
      });

    }
    else {
      state.allChecked = false;
      state.allIndeterminate = false;
      state.services = [];
      state.servicesSMS = [];
    }
    const _serviceSeverityGrid = { state, actions: { load, toggleAll, toggleService, toggleServiceSeverity } };
    return { serviceSeverityGrid: _serviceSeverityGrid, ...rest };
  })
);


export default connect;
